'use strict';

function TransactionSortModel(ModelFactory,
                              $rootScope,
                              TransactionFilterModel,
                              TransactionFieldModel) {
  var self = this;
  var fieldHistory = [];
  var directionHistory = [];
  var sortModel = ModelFactory.create('TransactionSortModel', [
    'sortOrder',
    'transactions'
  ]);

  var SORT_DESC = 'desc';
  var SORT_ASC = 'asc';


  var DEFAULT_SORT_COLUMN = 'date';
  var DEFAULT_SORTS = {
    date: SORT_DESC,
    merchantName: SORT_ASC,
    approvalStatus: SORT_ASC,
    amount: SORT_DESC,
    accountingField1: SORT_ASC,
    accountingField2: SORT_ASC,
    'details.travelerName': SORT_ASC,
    'details.ticketNumber': SORT_ASC,
    preAuthId: SORT_ASC,
    customizable: SORT_ASC
  };

  onInit();

  function onInit() {
    sortModel.sortOrder({
      field: DEFAULT_SORT_COLUMN,
      direction: DEFAULT_SORTS[ DEFAULT_SORT_COLUMN ]
    });

    fieldHistory = [sortModel.sortOrder().field , 'id'];
    directionHistory = [sortModel.sortOrder().direction, SORT_DESC];
  }
  
  self.sortField = function () {
    return _.get(sortModel.sortOrder(), 'field');
  };

  self.sortDirection = function () {
    return _.get(sortModel.sortOrder(), 'direction');
  };

  self.isSorted = function (fieldName) {
    return self.sortField() === fieldName;
  };

  self.isSortedAscending = function () {
    return self.sortDirection() === SORT_ASC;
  };

  self.isSortedDescending = function () {
    return self.sortDirection() === SORT_DESC;
  };

  self.setSortField = function (fieldName) {
    var newDirection;
    if (self.isSorted(fieldName)) {
      newDirection = oppositeDirection(self.sortDirection());
    } else {
      newDirection = _.get(DEFAULT_SORTS, fieldName, SORT_DESC);
    }

    sortModel.sortOrder({
      field: fieldName,
      direction: newDirection
    });
  };

  self.onTransactionsChanged = sortModel.onTransactionsChanged;
  self.onSortOrderChanged = sortModel.onSortOrderChanged;

  self.transactions = sortModel.transactions;

  function oppositeDirection(sortDirection) {
    if (sortDirection === SORT_DESC) {
      return SORT_ASC;
    } else {
      return SORT_DESC;
    }
  }

  function getLocalAmountAndCurrencyCode(transaction) {
    return _.get(transaction, 'details.localAmount');
  }

  function getMerchantLocation(transaction ) {
    return _.get(transaction, 'merchantCity', 'merchantState', 'merchantCountry').toLowerCase();
  }
  function getTRANSACTIONREFNUMBER(transaction) {
    return _.get(transaction, 'transRefNo', '');
  }
  function getCardmemberName(transaction) {
    return _.get(transaction, 'cardmemberName', '').toLowerCase();
  }
  function getCardmemberNameAndNumber(transaction) {
    return _.get(transaction, 'cardmemberName', 'cardNumber').toLowerCase();
  }
  function getAllocationDescription(transaction) {
    var allocations = _.get(transaction, 'allocations', []);
    var desc = _.get(allocations[0], 'description', '');
    return !desc ? '' : desc.toLowerCase();
  }
  function getCardmemberReference1(transaction) {
    return _.get(transaction, 'details.cardmemberReference1', '').toLowerCase();
  }
  function getCardmemberReference2(transaction) {
    return _.get(transaction, 'details.travelerName', '').toLowerCase();
  }
  function getCardmemberReference3(transaction) {
    return _.get(transaction, 'details.cardmemberReference3', '').toLowerCase();
  }
  function getCardmemberReference4(transaction) {
    return _.get(transaction, 'details.cardmemberReference4', '').toLowerCase();
  }
  function getDescription1(transaction) {
    return _.get(transaction, 'details.descriptionLine1', '').toLowerCase();
  }
  function getDescription2(transaction) {
    return _.get(transaction, 'details.descriptionLine2', '').toLowerCase();
  }
  function getDescription3(transaction) {
    return _.get(transaction, 'details.descriptionLine3', '').toLowerCase();
  }
  function getDescription4(transaction) {
    return _.get(transaction, 'details.routing', '').toLowerCase();
  }
  function applySort(transactions) {
    var sortInfo = sortModel.sortOrder();
    var sortField = sortInfo.field;
    var sortDirection = sortInfo.direction;

    if(sortField !== undefined && sortField.toString() != undefined && startsWordWith(sortField,'ACF')) {
      var position = Number(sortField.substring(3));
      if(transactions[0]) {
        sortField = function( transaction ){
          var allocations = _.get(transaction, 'allocations', []);
          var accountingFieldValue = -1;
          if (allocations[0]) {
            accountingFieldValue = _.find( allocations[0].accountingFieldValues , ['position', position]);
          }

          if( position === -1 ){
            var desc = _.get(allocations[0], 'description', '');
            return !desc ? '' : desc.toLowerCase();

          }else {
            var accountingFV = _.get(accountingFieldValue, 'value', '');
            return !accountingFV ? '' : accountingFV.toLowerCase();
          }
        };
      }
    } else {
      switch (sortField.toString()) {
        case 'preAuthId':
          sortField = preAuthIdSorter;
          break;
        case 'merchant name 1':
          sortField = merchantDisplayName1Sorter;
          break;
        case 'merchant name 2':
          sortField = merchantDisplayName2Sorter;
          break;
        case 'lockStatus':
          sortField = lockTypeSorter;
          break;
        case 'receiptsPresent':
          sortField = receiptSorter;
          break;
        case 'Local Amount & Currency Code'.toLowerCase():
          sortField = getLocalAmountAndCurrencyCode;
          break;
        case 'transaction reference number':
          sortField = getTRANSACTIONREFNUMBER;
          break;
        case 'mutableTransactionProperties.transactionStatus':
        case 'details.exceptionFlag':
        case 'lineItemDetails.hasLineItems':
        case 'transactionThirdPartyData':
        case 'mutableTransactionProperties.commentIndicator':
        case 'mutableTransactionProperties.accountingManagerApproved':
        case 'mutableTransactionProperties.cardManagerApproved':
        case 'mutableTransactionProperties.bcaManagerApproved':
        case 'mutableTransactionProperties.cardmemberSubmitted':
        case 'date':
          break;
        case 'Billed Tax Amount'.toLowerCase():
          sortField = 'details.billedTaxAmount';
          break;
        case 'allocation description':
          sortField = getAllocationDescription;
          break;
        case 'last updated':
          sortField = 'updatedAt';
          break;
        case 'merchant location':
          sortField = getMerchantLocation;
          break;
        case 'description 1':
          sortField = getDescription1;
          break;
        case 'description 2':
          sortField = getDescription2;
          break;
        case 'description 3':
          sortField = getDescription3;
          break;
        case 'description 4':
          sortField = getDescription4;
          break;
        case 'merchant reference number':
          sortField = 'details.merchantReference';
          break;
        case 'cardmember name':
          sortField = getCardmemberName;
          break;
        case 'cardmember name and card number':
          sortField = getCardmemberNameAndNumber;
          break;
        case 'business process date':
          sortField = 'processDate';
          break;
        case 'ticket number':
          sortField = 'details.ticketNumber';
          break;
        case 'traveler name':
          sortField = getCardmemberReference2;
          break;
        case 'cardmember reference 1':
            sortField = getCardmemberReference1;
          break;
        case 'cardmember reference 2':
          sortField = getCardmemberReference2;
          break;
        case 'cardmember reference 3':
          sortField = getCardmemberReference3;
          break;
        case 'cardmember reference 4':
          sortField = getCardmemberReference4;
          break;
        default: {
          var selectedHeadr = _.filter(TransactionFieldModel.selectedHeaderColumnsArray, function (colHeader) {

            if (startsWordWith(colHeader.type, 'ACF')) {
              return false;
            } else {
              return colHeader.displayValue.toLowerCase() === sortField.toString().toLowerCase();
            }
          });

          if (selectedHeadr.length > 0 && selectedHeadr[0].transactionDBFieldName !== undefined) {
            TransactionFieldModel.selectedField(selectedHeadr[0].transactionDBFieldName.toString());
          }
          sortField = TransactionFieldModel.getFieldValue;
        }
      }
    }

    updateSortHistory(sortField,sortDirection);
    return _.orderBy(transactions, fieldHistory, directionHistory);
  }

  function startsWordWith(str, word) {
    return str!== undefined && str.lastIndexOf(word, 0) === 0;
  }

  function updateSortHistory(sortField, sortDirection) {
    if(_.includes(fieldHistory, sortField)) {
      var index = _.indexOf(fieldHistory, sortField);
      fieldHistory.splice(index, 1);
      directionHistory.splice(index, 1);
    }
    fieldHistory.unshift(sortField);
    directionHistory.unshift(sortDirection);
  }

  function preAuthIdSorter(transaction) {
    if(transaction.preAuthData && transaction.preAuthData.length > 0) {
      return _.get(transaction.preAuthData[0].id, 'preAuthorizationId', '');
    } else {
      return '';
    }
  }

  function onTransactionsOrSortOrderChanged () {
    sortModel.transactions(applySort(TransactionFilterModel.transactions()));
  }

  function merchantDisplayName1Sorter(transaction) {
    return transaction.merchantName;
  }
  function merchantDisplayName2Sorter(transaction) {
    return transaction.merchantName2;
  }

  function lockTypeSorter(transaction) {
    if(transaction.transactionHold && transaction.transactionHold.hold) {
      return 'HELD';
    } else {
      return transaction.lockStatus;
    }
  }

  function receiptSorter(transaction) {
    return transaction.receiptIds.length > 0;
  }

  sortModel.onSortOrderChanged($rootScope, onTransactionsOrSortOrderChanged);
  TransactionFilterModel.onTransactionsChanged($rootScope, onTransactionsOrSortOrderChanged);

  return self;
}

angular.module('amexReconciliationApp')
    .service('TransactionSortModel', TransactionSortModel);



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/TransactionSortModel.js
// module id = 593
// module chunks = 0